import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = __SUPABASE_URL__;
const publishableKey = __SUPABASE_PUBLISHABLE_KEY__;

/**
 * Browser client for Supabase Auth and RLS-protected tables.
 *
 * Returns null when the public Supabase configuration is missing so the app
 * can keep running the legacy backend during the migration. The secret key is
 * server-only and must never be embedded here.
 */
export const supabase: SupabaseClient | null =
  url && publishableKey
    ? createClient(url, publishableKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      })
    : null;

export const hasSupabaseAuth = supabase !== null;

/** Matches the entitlement environment written by the active payment adapter. */
export const SUPABASE_ENVIRONMENT: 'sandbox' | 'live' = __SUPABASE_ENVIRONMENT__;

/** Enables the new checkout panel; empty while the legacy checkout is still active. */
export const SUPABASE_CHECKOUT: '' | 'sandbox' | 'live' = __SUPABASE_CHECKOUT__;
